import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigIFSC } from './config'

const responseParser = (data: any) => {
  return data
}

const getBranchDetailsByIfsc = (ifsc: string, tokens: any, userAccessToken: string) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.validateIFSC,
    method: 'POST',
    body: { ifscCode: ifsc },
    config: sitConfigIFSC(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken ?? '',
    },
    cache: false,
  }
  return executeRequest(request).then((response) => {
    return responseParser(response?.data?.response)
  })
}

export { getBranchDetailsByIfsc }
